import { Injectable, OnDestroy, NgZone } from '@angular/core';
import { Subject } from "rxjs";
import { Observable } from "rxjs";
import { WindowSize } from '../window-size.enum';

// TODO: Add Angular decorator.
@Injectable()
export class MediaQueryService implements OnDestroy {

  private rules = {
    xs: '(max-width: 767px)',
    sm: '(min-width: 768px) and (max-width: 991px)',
    md: '(min-width: 992px) and (max-width: 1199px)',
    lg: '(min-width: 1200px)'
  }
  isXs: boolean = false;
  isSm: boolean = false;
  isMd: boolean = false;
  isLg: boolean = false;


  private mql_xs: MediaQueryList
  private mql_sm: MediaQueryList
  private mql_md: MediaQueryList
  private mql_lg: MediaQueryList

  private subjectWindowSizeChanged = new Subject<WindowSize>();

  constructor(zone: NgZone) {

    window['edr_mediaQueryService'] = {
      zone: zone,
      notifySizeChange: (size)=> this.notifySizeChange(size),
      component: this
    };

    this.isXs = this.checkMediaRule(this.rules.xs);
    this.isSm = !this.isXs && this.checkMediaRule(this.rules.sm);
    this.isMd = !this.isXs && !this.isSm && this.checkMediaRule(this.rules.md);
    this.isLg = !this.isXs && !this.isSm && !this.isMd && this.checkMediaRule(this.rules.lg);
    this.mql_xs = this.addMediaListener(this.onXs, this.rules.xs);
    this.mql_sm = this.addMediaListener(this.onSm, this.rules.sm);
    this.mql_md = this.addMediaListener(this.onMd, this.rules.md);
    this.mql_lg = this.addMediaListener(this.onLg, this.rules.lg);
    this.subjectWindowSizeChanged.next(this.getWindowSize());
  }

  ngOnDestroy() {
    this.removeMediaListener(this.mql_xs, this.onXs);
    this.removeMediaListener(this.mql_sm, this.onSm);
    this.removeMediaListener(this.mql_md, this.onMd);
    this.removeMediaListener(this.mql_lg, this.onLg);
  }

  getWindowSize(): WindowSize {
    if (this.isXs)
      return WindowSize.xs;
    if (this.isSm)
      return WindowSize.sm;
    if (this.isMd)
      return WindowSize.md;
    if (this.isLg)
      return WindowSize.lg;
  }

  checkMediaRule(rule): boolean {
    return window.matchMedia(rule).matches;
  }

  addMediaListener(callBack, rule): MediaQueryList {
    let mql: MediaQueryList;
    if (typeof callBack === 'function') {
      mql = window.matchMedia(rule);
      mql.addListener(callBack);
    }
    return mql;
  }
  removeMediaListener(mediaQuery: MediaQueryList, callBack) {
    mediaQuery.removeListener(callBack);
  }

  private onXs(mql: MediaQueryList) {
    if (mql.matches) {

      window['edr_mediaQueryService'].zone.run(() => {
        window['edr_mediaQueryService'].notifySizeChange('xs');
      });
    }
  }
  private onSm(mql: MediaQueryList) {
    if (mql.matches) {
      window['edr_mediaQueryService'].zone.run(() => {
        window['edr_mediaQueryService'].notifySizeChange('sm');

      });
    }
  }
  private onMd(mql: MediaQueryList) {
    if (mql.matches) {
      window['edr_mediaQueryService'].zone.run(() => {
        window['edr_mediaQueryService'].notifySizeChange('md');
      });
    }
  }
  private onLg(mql: MediaQueryList) {
    if (mql.matches) {
      window['edr_mediaQueryService'].zone.run(() => {
        window['edr_mediaQueryService'].notifySizeChange('lg');
      });
    }
  }

changeXs()
{

}

  private notifySizeChange(size) {
    this.isXs = size === 'xs';
    this.isSm = size === 'sm';
    this.isMd = size === 'md';
    this.isLg = size === 'lg';
    this.subjectWindowSizeChanged.next(this.getWindowSize());
  }

  public get onWindowSizeChanged():Observable<WindowSize>{
    return this.subjectWindowSizeChanged.asObservable();
    }


}


